/* eslint-disable import/no-anonymous-default-export */
export default {
  primary: {
    main: "#405189",
    600: "#364574",
    500: "#405189",
    100: "#3d4f8b0d",
  },
  white: {
    main: "#FFFFFF",
  },
  blue: {
    main: "#0288d1",
  },
  red: {
    main: "#ff3333",
  },
};
